import { ImageMap } from './_imageMap';

interface DebugOptions {
  enabled: boolean;
}

const DEBUG_DEFAULT: DebugOptions = {
  enabled: false,
};

class DebugUtil {
  private enabled: boolean;
  private prefix: string;

  constructor(enabled: boolean, prefix: string = '') {
    this.enabled = enabled;
    this.prefix = prefix ? `[${prefix}] ` : '';
  }

  log(...args: any[]): void {
    if (this.enabled) {
      console.debug(this.prefix, ...args);
    }
  }
}

export class ImageMapManager {
  private imageMaps: ImageMap[] = [];
  private debug: DebugUtil;
  private debugOptions: DebugOptions;
  private observer: MutationObserver;

  constructor(debugOptions: DebugOptions = DEBUG_DEFAULT) {
    this.debug = new DebugUtil(debugOptions.enabled, 'ImageMapManager');
    this.debugOptions = debugOptions;
    this.debug.log('Constructor called');

    // MutationObserverを利用してDOMの変化を監視し、.ist-js__imageMap要素が追加されたら初期化
    this.observer = new MutationObserver((mutations) => {
      this.debug.log('DOM mutations detected:', mutations);
      let shouldInit = false;

      mutations.forEach((mutation) => {
        if (mutation.addedNodes.length > 0) {
          mutation.addedNodes.forEach((node) => {
            if (node instanceof HTMLElement) {
              if (
                node.classList.contains('ist-js__imageMap') ||
                node.querySelector('.ist-js__imageMap')
              ) {
                shouldInit = true;
              }
            }
          });
        }
      });

      if (shouldInit) {
        this.initializeImageMaps();
      }
    });

    // DOMContentLoaded後に初期化処理
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => this.init());
    } else {
      this.init();
    }
  }

  private init(): void {
    this.debug.log('Initializing');
    this.initializeImageMaps();

    this.debug.log('Setting up MutationObserver');
    this.observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
  }

  private initializeImageMaps(): void {
    const containers = document.querySelectorAll(
      '.ist-js__imageMap:not([data-initialized])'
    );
    this.debug.log('Found initial containers:', containers);

    containers.forEach((container) => {
      container.setAttribute('data-initialized', 'true');
      this.imageMaps.push(new ImageMap(container, this.debugOptions));
    });
  }

  public destroy(): void {
    this.debug.log('Destroying ImageMapManager');
    this.observer.disconnect();
    this.imageMaps.forEach((imageMap) => {
      if (typeof imageMap.destroy === 'function') {
        imageMap.destroy();
      }
    });
    this.imageMaps = [];
  }
}
